import React from "react";
import { Check } from "lucide-react";
import MarketingLayout from "../../components/marketing/MarketingLayout";
import Seo from "../../components/Seo";
import AuditForm from "../../components/marketing/AuditForm";

export default function LeadSystemAudit() {
  return (
    <MarketingLayout hideStickyCta>
      <Seo title="Free Lead System Audit — AllToMAIDIt" description="Find out where your lead process is working and where opportunities are being lost. Get a free Lead System Audit." />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12 py-14 lg:py-20 grid lg:grid-cols-5 gap-10 items-start">
        <div className="lg:col-span-2 lg:sticky lg:top-24">
          <p className="eyebrow text-alto-red mb-4">Free Lead System Audit</p>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold leading-[0.95]">FIND THE LEADS<br />YOU'RE <span className="text-alto-red">LOSING.</span></h1>
          <p className="text-neutral-300 mt-6 text-sm sm:text-base leading-relaxed">Tell us how your business captures and follows up with leads today. We'll review it and show you exactly where opportunities are slipping — and what to do about it.</p>
          <ul className="mt-7 space-y-3">
            {["A clear picture of where leads enter your business", "Where follow-up is breaking down", "Which sources you can actually track", "A practical plan to capture more customers"].map((t) => (
              <li key={t} className="flex items-start gap-3 text-neutral-200 text-sm"><Check className="text-alto-red shrink-0 mt-0.5" size={17} />{t}</li>
            ))}
          </ul>
          <p className="text-xs text-neutral-500 mt-7">No cost. No obligation. We respond within one business day.</p>
        </div>
        <div className="lg:col-span-3">
          <AuditForm campaign="Lead System Audit" />
        </div>
      </div>
    </MarketingLayout>
  );
}
